import React, { useState, useEffect } from 'react';

const GoogleDriveImage = ({ fileId, alt = 'Image', width = 60, height = 60, ...props }) => {
  const [currentUrlIndex, setCurrentUrlIndex] = useState(0);
  const [hasError, setHasError] = useState(false);

  // Différents formats d'URL Google Drive à tester (ordre optimisé)
  const urlFormats = [
    // Format thumbnail - plus fiable pour l'affichage
    `https://drive.google.com/thumbnail?id=${fileId}&sz=w400-h400`,
    `https://drive.google.com/thumbnail?id=${fileId}&sz=w200-h200`,
    `https://drive.google.com/thumbnail?id=${fileId}&sz=w100-h100`,
    // Format lh3 - alternative Google
    `https://lh3.googleusercontent.com/d/${fileId}`,
    `https://lh3.googleusercontent.com/d/${fileId}=w400-h400`,
    `https://lh3.googleusercontent.com/d/${fileId}=w200-h200`,
    // Format docs - fallback
    `https://docs.google.com/uc?export=view&id=${fileId}`,
    // Format uc - dernier recours (souvent bloqué par CORS)
    `https://drive.google.com/uc?export=view&id=${fileId}`
  ];

  const currentUrl = urlFormats[currentUrlIndex];

  const handleError = () => {
    if (currentUrlIndex < urlFormats.length - 1) {
      // Essayer l'URL suivante
      setCurrentUrlIndex(currentUrlIndex + 1);
    } else {
      // Toutes les URLs ont échoué
      setHasError(true);
    }
  };

  const handleLoad = () => {
    // Image chargée avec succès
  };

  // Reset quand le fileId change
  useEffect(() => {
    setCurrentUrlIndex(0);
    setHasError(false);
  }, [fileId]);

  if (hasError) {
    return (
      <div 
        style={{ 
          width, 
          height, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: '#f7fafc',
          border: '2px dashed #e2e8f0',
          borderRadius: '8px',
          color: '#cbd5e0'
        }}
      >
        <i className="fas fa-image" style={{ fontSize: '24px' }}></i>
      </div>
    );
  }

  return (
    <img
      src={currentUrl}
      alt={alt}
      width={width}
      height={height}
      onError={handleError}
      onLoad={handleLoad}
      style={{
        objectFit: 'cover',
        borderRadius: '8px'
      }}
      {...props}
    />
  );
};

export default GoogleDriveImage;
